import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetCompanyUserTableData: '[GetCompanyUserTableData] Action',
  GetCompanyUserTranslateData: '[GetCompanyUserTranslateData] Action',
  GetDeviceInfoTableData: '[GetDeviceInfoTableData] Action',
  GetDeviceTranslateData: '[GetDeviceTranslateData] Action',
  GetDeviceInfoTranslateData: '[GetDeviceInfoTranslateData] Action',
  GetUserSettingsTableData: '[GetUserSettingsTableData] Action',
  GetUserSettingsTranslateData: '[GetUserSettingsTranslateData] Action',
  SetCompanyUserData: '[SetCompanyUserData] Action',
  SetDeviceData: '[SetDeviceData] Action',
}

const initialUserState: IUserState = {
  userColumnList: [],
  userColumnValues: [],
  userDefinitions: [],
  userColumnNames: [],
  userDataTypes: [],
  userDe: [],
  userEn: [],

  deviceColumnValues: [],
  deviceColumnList: [],
  deviceDefinitions: [],
  deviceColumnNames: [],
  deviceDataTypes: [],
  deviceDe: [],
  deviceEn: [],

  deviceOptions: [],

  licencesPerUser: [],
  licencesInfoPerUser: [],

  deviceInfoColumnList: [],
  deviceInfoColumnValues: [],
  deviceInfoDefinitions: [],
  deviceInfoDe: [],
  deviceInfoEn: [],
  maxid: "",

  userSettingsColumnList: [],
  userSettingsColumnValues: [],
  userSettingsDefinitions: [],
  userSettingsDe: [],
  userSettingsEn: [],

}

export interface IUserState {
  userColumnList: [],
  userColumnValues: [],
  userDefinitions: [],
  userColumnNames: [],
  userDataTypes: [],
  userDe: [],
  userEn: [],

  deviceColumnValues: [],
  deviceColumnList: [],
  deviceDefinitions: [],
  deviceColumnNames: [],
  deviceDataTypes: [],
  deviceDe: [],
  deviceEn: [],

  deviceOptions: [],

  licencesPerUser: [],
  licencesInfoPerUser: [],

  deviceInfoColumnList: [],
  deviceInfoColumnValues: [],
  deviceInfoDefinitions: [],
  deviceInfoDe: [],
  deviceInfoEn: [],
  maxid: any,

  userSettingsColumnList: [],
  userSettingsColumnValues: [],
  userSettingsDefinitions: [],
  userSettingsDe: [],
  userSettingsEn: [],

}

export const reducer = persistReducer(
  { storage, key: 'portal-user', whitelist: [] },
  (state: IUserState = initialUserState, action: any) => {
    switch (action.type) {
      case actionTypes.GetCompanyUserTableData: {
        const userColumnValues = action.payload.data.companyUsers;
        let headers = JSON.parse(action.payload.data.headers);
        let userDefinitions = JSON.parse(action.payload.data.definitions);
        let deviceHeaders = JSON.parse(action.payload.data.deviceHeaders);
        let deviceDefinitions = JSON.parse(action.payload.data.deviceDefinitions);
        let licencesPerUser = JSON.parse(action.payload.data.licencesPerUser);
        let licencesInfoPerUser = JSON.parse(action.payload.data.licencesInfoPerUser);
        let deviceColumnValues = action.payload.data.devices;
        let deviceOptions = action.payload.data.deviceOptions;
        let userColumnNames = action.payload.data.columnNames;
        let userDataTypes = action.payload.data.dataTypes;
        let deviceColumnNames = action.payload.data.deviceColumnNames;
        let deviceDataTypes = action.payload.data.deviceDataTypes;
        let userColumnList: any = [];
        let deviceColumnList: any = [];

        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          userColumnList.push(newElement[0]);
        });
        deviceHeaders.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          deviceColumnList.push(newElement[0]);
        });
        return { ...state, userColumnList, userColumnValues, userDefinitions, licencesPerUser, userDataTypes, userColumnNames, licencesInfoPerUser, deviceColumnValues, deviceOptions, deviceColumnList, deviceHeaders, deviceColumnNames, deviceDataTypes, deviceDefinitions };
      }

      case actionTypes.GetDeviceInfoTableData: {
        let deviceInfoColumnValues = action.payload.data.values;
        let headers = JSON.parse(action.payload.data.headers);
        let deviceInfoDefinitions = JSON.parse(action.payload.data.definitions);
        let deviceInfoColumnList: any = [];
        const maxid = action.payload.data.maxid;
        deviceInfoColumnValues.forEach((element: any) => {
          element['backlog'] = +maxid - (+element['lasttranid']);
        });

        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          deviceInfoColumnList.push(newElement[0]);
        });
        return { ...state, deviceInfoColumnList, deviceInfoColumnValues, deviceInfoDefinitions, maxid };
      }

      case actionTypes.GetUserSettingsTableData: {
        let userSettingsColumnValues = action.payload.data.settings;
        let headers = JSON.parse(action.payload.data.headers);
        let userSettingsDefinitions = JSON.parse(action.payload.data.definitions);
        let userSettingsColumnList: any = [];
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          userSettingsColumnList.push(newElement[0]);
        });
        return { ...state, userSettingsColumnList, userSettingsColumnValues, userSettingsDefinitions };
      }

      case actionTypes.GetCompanyUserTranslateData: {
        const userDe = JSON.parse(action.payload.data.de);
        const userEn = JSON.parse(action.payload.data.en);
        return { ...state, userDe, userEn };
      }

      case actionTypes.GetDeviceTranslateData: {
        const deviceDe = JSON.parse(action.payload.data.de);
        const deviceEn = JSON.parse(action.payload.data.en);
        return { ...state, deviceDe, deviceEn };
      }
      case actionTypes.GetDeviceInfoTranslateData: {
        const deviceInfoDe = JSON.parse(action.payload.data.de);
        const deviceInfoEn = JSON.parse(action.payload.data.en);
        return { ...state, deviceInfoDe, deviceInfoEn };
      }
      case actionTypes.GetUserSettingsTranslateData: {
        const userSettingsDe = JSON.parse(action.payload.data.de);
        const userSettingsEn = JSON.parse(action.payload.data.en);
        return { ...state, userSettingsDe, userSettingsEn };
      }

      case actionTypes.SetCompanyUserData: {
        const userColumnValues = action.payload.data;
        return { ...state, userColumnValues };
      }
      case actionTypes.SetDeviceData: {
        const deviceColumnValues = action.payload.data;
        return { ...state, deviceColumnValues };
      }

      default:
        return state
    }
  }
)

export const actions = {
  getTableData: (data: any) => ({ type: actionTypes.GetCompanyUserTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetCompanyUserTranslateData, payload: { data } }),
  getDeviceInfoTranslateData: (data: any) => ({ type: actionTypes.GetDeviceInfoTranslateData, payload: { data } }),
  getDeviceInfoTableData: (data: any) => ({ type: actionTypes.GetDeviceInfoTableData, payload: { data } }),
  getUserSettingsTableData: (data: any) => ({ type: actionTypes.GetUserSettingsTableData, payload: { data } }),
  getDeviceTranslateData: (data: any) => ({ type: actionTypes.GetDeviceTranslateData, payload: { data } }),
  getUserSettingsTranslateData: (data: any) => ({ type: actionTypes.GetUserSettingsTranslateData, payload: { data } }),
  setCompanyUserData: (data: any) => ({ type: actionTypes.SetCompanyUserData, payload: { data } }),
  setDeviceData: (data: any) => ({ type: actionTypes.SetDeviceData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
